import React from "react";

import { LoadingPageRefProps } from "@/components/molecules/LoadingPage/LoadingPageContainer";

export const loadingPageRef = React.createRef<LoadingPageRefProps>();
